<template>
    <nav aria-labelledby="paginationHeading">
        <span class="sr-only" id="paginationHeading" role="status" aria-live="polite">
            Výsledky stránkovače - stránka {{ currentPage }} z {{ totalPages }}
        </span>
        <ul v-if="totalPages > 1" class="ds-pagination">
            <li class="ds-pagination__arrow" :class="{ 'ds-pagination__arrow--disabled': leftArrowDisabled }">
                <DsButton
                    @click="onClickHandler(currentPage - 1)"
                    aria-label="Předešlá stránka"
                    type="interaction"
                    :theme="theme"
                    :is-disabled="leftArrowDisabled"
                    icon-left="arrow-left"
                >
                </DsButton>
            </li>

            <template v-if="currentPage === 1">
                <PaginationItem type="activeItem" :page-number="1" />
            </template>
            <template v-else>
                <PaginationItem type="item" :page-number="1" :on-click-handler="onClickHandler" />
            </template>

            <template v-if="currentPage > 3 && totalPages > 6">
                <PaginationItem type="dots" />
            </template>

            <template v-for="(page, index) in getArrayOfPages" :key="page">
                <template v-if="!(page === 1 || page === totalPages)">
                    <template v-if="page === currentPage">
                        <PaginationItem type="activeItem" :page-number="page" />
                    </template>
                    <template v-else>
                        <PaginationItem
                            type="item"
                            :page-number="page"
                            :hide-on-xs="index === 0 || (totalPages > 6 && index === 4)"
                            :on-click-handler="onClickHandler"
                        />
                    </template>
                </template>
            </template>

            <template v-if="currentPage < totalPages - 3 && totalPages > 6">
                <PaginationItem type="dots" />
            </template>

            <template v-if="currentPage === totalPages">
                <PaginationItem type="activeItem" :page-number="totalPages" />
            </template>
            <template v-else>
                <PaginationItem type="item" :page-number="totalPages" :on-click-handler="onClickHandler" />
            </template>

            <li class="ds-pagination__arrow" :class="{ 'ds-pagination__arrow--disabled': rightArrowDisabled }">
                <DsButton
                    @click="onClickHandler(currentPage + 1)"
                    aria-label="Nasledující stránka"
                    type="interaction"
                    :theme="theme"
                    :is-disabled="rightArrowDisabled"
                    icon-right="arrow-right"
                ></DsButton>
            </li>
        </ul>
    </nav>
</template>
<script lang="ts" setup>
import { computed, ComputedRef } from "vue";
import DsButton from "../button/ds-button.vue";
import PaginationItem from "../pagination-item/pagination-item.vue";
import type { Theme } from "../types/theme";

const props = withDefaults(
    defineProps<{
        totalPages: number;
        currentPage: number;
        theme?: Theme;
        onClickHandler: (pageNumber: number) => void;
    }>(),
    {
        theme: "light",
    }
);

const leftArrowDisabled = computed(() => props.currentPage == 1);
const rightArrowDisabled = computed(() => props.currentPage == props.totalPages);

const getArrayOfPages: ComputedRef<number[]> = computed(() => {
    if (props.totalPages < 7) {
        return Array.from({ length: props.totalPages }, (_, i) => i + 1);
    } else if (props.currentPage <= 3) {
        return [1, 2, 3, 4, 5];
    } else if (props.currentPage === 4 && props.totalPages == 7) {
        return [3, 4, 5, 6];
    } else if (props.currentPage === 4 && props.totalPages > 7) {
        return [3, 4, 5];
    } else if (props.currentPage >= props.totalPages - 3) {
        return [4, 3, 2, 1, 0].map((item) => props.totalPages - item);
    } else {
        return [-1, 0, 1].map((item) => props.currentPage + item);
    }
});
</script>
